import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Programs from "./components/Programs";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Success from "./components/Success";
import Gallery from "./components/Gallery";
import AdmissionForm from "./components/AdmissionForm";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import GroundBooking from "./pages/GroundBooking";
import AcademyBooking from "./pages/AcademyBooking";
import TournamentRegistration from "./pages/TournamentRegistration";
import ContactEnquiry from "./pages/ContactEnquiry";
import Booking from "./pages/Booking";

function Home() {
  return (
    <>
      <Hero />
      <About />
      <Gallery />
      <Success />
      <Programs />
      <AdmissionForm />
      <Contact />
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <div className="font-sans">

        <Navbar />

        <Routes>
          {/* Home page */}
          <Route path="/" element={<Home />} />

          {/* Booking page */}
          <Route path="/booking" element={<Booking />} />

          {/* Individual booking pages */}
          <Route
            path="/ground-booking"
            element={<GroundBooking />}
          />

          <Route
            path="/academy-booking"
            element={<AcademyBooking />}
          />

          <Route
            path="/tournament-registration"
            element={<TournamentRegistration />}
          />

          <Route
            path="/contact-enquiry"
            element={<ContactEnquiry />}
          />
        </Routes>

      </div>
    </BrowserRouter>
  );
}